import { businessCardRoutes } from "./business-card.routes";
import { stationaryRoutes } from "./stationary-request.routes";

export const companyOfficeRoutes = {
  ...businessCardRoutes,
  ...stationaryRoutes,
};
